import { ref } from "vue";

/**
 * 画面表示に関わる UI 状態を管理する composable。
 *
 * @returns 画面で利用するリアクティブな状態オブジェクト
 */
export const useDeliveryMoveUiState = () => {
  const errdialog = ref(false);
  const errMessage = ref("");
  const editPage = ref(false);
  const confirmPage = ref(false);
  const panel = ref<number[]>([0]);
  const processFlag = ref(0);
  const confirmDeleteDialog = ref(false);
  const overlay = ref(false);
  const downloadingDialog = ref(false);
  const displayListSettingDialog = ref(false);
  const displayListSearchDialog = ref(false);

  const onClickListSearch = (): void => {
    // 一覧設定ダイアログ表示
    displayListSearchDialog.value = true;
  };

  /**
   * 配達依頼一覧ページ 開く
   */
  const openListPage = (): void => {
    // 編集ページ表示 OFF
    editPage.value = false;

    // 確認ページ表示 OFF
    confirmPage.value = false;

    // loading OFF
    overlay.value = false;
  };

  /**
   * 配達依頼確認ページ 開く
   */
  const openConfirmPage = (): void => {
    // 編集ページ表示 ON
    editPage.value = false;

    // 確認ページ表示 ON
    confirmPage.value = true;
  };

  return {
    errdialog,
    errMessage,
    editPage,
    confirmPage,
    panel,
    processFlag,
    confirmDeleteDialog,
    overlay,
    downloadingDialog,
    displayListSettingDialog,
    displayListSearchDialog,
    onClickListSearch,
    openListPage,
    openConfirmPage,
  };
};
